import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MediaService {
  private baseURL = environment.apiUrl;

  private get token(): string {
    return localStorage.getItem('b2b_token')?.toString() || '';
  }

  constructor(private http: HttpClient) {}

  public uploadMedia(file: File, entityId: string, entityType: number, usageType: number): Observable<any> {
    const formData = new FormData();
    formData.append('File', file);
    formData.append('EntityId', entityId);
    formData.append('EntityType', entityType.toString());
    formData.append('UsageType', usageType.toString());
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    };
    return this.http.post(this.baseURL + `media/upload`, formData, { headers: header });
  }

  public keepMedia(imagePath: string): Observable<any> {
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    };
    return this.http.delete(this.baseURL + `media/keep?imagePath=${encodeURIComponent(imagePath)}`, { headers: header });
  }

  public deleteMedia(imagePath: string): Observable<any> {
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    };
    return this.http.delete(this.baseURL + `media/delete?imagePath=${encodeURIComponent(imagePath)}`, { headers: header });
  }
}
